export interface CompanyFormData {
	company_name: string;
	primary_color: string;
	secondary_color: string;
	hide_electricity: boolean;
	email_host: string;
	email_port: number;
	email_username: string;
	email_password: string;
	email_from_email: string;
}

export const EMPTY_COMPANY_FORM: CompanyFormData = {
	company_name: "",
	primary_color: "#000000",
	secondary_color: "#000000",
	hide_electricity: false,
	email_host: "",
	email_port: 25,
	email_username: "",
	email_password: "",
	email_from_email: "",
};
